import React from 'react';
import {useTranslation} from 'react-i18next';

import getIconByType from '../../../getIconByType';
import getTitleByType from '../../../getTitleByType';
import {getDateByCustomFormat, DATE_FORMATS} from 'utils/date';
import {Layout, Text, WarningIcon} from '@phonectas/unifon-ui-kit';
import EventDescription from '../EventDescription';
import {EventData} from './types';
import LightningIcon from 'common/components/icons/LightningIcon';

const UpsellEvent: React.FC<EventData> = ({data}) => {
	const [t] = useTranslation();
	const isWarning = data?.is_warning;

	return (
		<Layout gap="sm" fullWidth nowrap fullHeight>
			<Layout direction="column" nowrap gap="md" alignItems="center" style={{width: '42px'}}>
				<Layout>
					{getIconByType(data?.feed_type)}
                    
				</Layout>
				<Layout>
					{
						isWarning && (
							<Layout>
								<WarningIcon color="warning" />
							</Layout>
						)
					}
				</Layout>
			</Layout>
			<Layout direction="column" fullWidth nowrap>
				<Layout direction="row"gap="sm" fullWidth nowrap>
					<Layout direction="column" fullWidth nowrap gap="xs">
						<Layout
							direction="row"
							gap="xs"
							fullWidth
							alignItems="center"
							justifyContent="space-between"
							nowrap
						>
							<Layout nowrap gap="xs" alignItems="center">
								<Text variant="h3">{getTitleByType(data?.feed_type)}</Text>
								<LightningIcon />
							</Layout>
							<Layout nowrap>
								<Text color="textSecondary" variant="body1">
									{
										getDateByCustomFormat(data?.created_at, DATE_FORMATS.DD_MM_YY_HH_mm)
									}
								</Text>
							</Layout>
						</Layout>
						<Layout fullWidth direction="row" nowrap>
							<Layout fullWidth gap="none">
								<Layout
									direction="row"
									justifyContent="space-between"
									fullWidth
									alignItems="center"
									gap="none"
								>
									<Text color="textSecondary" style={{alignItems: 'center'}} variant="body1">
										{data?.data_fields?.actor_name}
									</Text>
								</Layout>
							</Layout>
						</Layout>
						<Layout direction="row" nowrap>
							<EventDescription
								description={
									data?.data_fields?.body ||
                                    t('No description available')
								}
							/>
						</Layout>
						<Layout direction="row" fullWidth style={{gap: '8px'}}>
						</Layout>
					</Layout>
				</Layout>
			</Layout>
		</Layout>
	);
}

export default UpsellEvent;
